// src/components/CustomerSummary/components/SupportTicketsResolvedTable.jsx
// ============================================================================
// BLOCK CS.UI.STR.0 — SupportTicketsResolvedTable (read-only + resizable)
// ----------------------------------------------------------------------------
// INPUT FORMAT (tab-delimited; 2 columns)
// ============================================================================

import React from 'react';

import ResizableTextTable from './ResizableTextTable.jsx';
import { TABLE_FORMATS } from './tableFormats.js';

export default function SupportTicketsResolvedTable({ text, columnWidths, onColumnWidthsChange }) {
  return (
    <ResizableTextTable
      text={text}
      columnWidths={columnWidths}
      onColumnWidthsChange={onColumnWidthsChange}
      format={TABLE_FORMATS.supportTicketsResolved}
    />
  );
}
